export function addIdAndCast<T>(doc: { id: string; data: () => any }) {
    return { ...doc.data(), id: doc.id } as T;
}
